import { appConfig } from "../../system/types/app/appConfig";

export enum SYSTEM_ACTIONS {
    systemToggleDarkTheme = 'SYSTEM_TOGGLE_DARK_THEME',
    systemSetLanguages = 'SYSTEM_SET_LANUGAGES',
    systemSetAppConfig = 'SYSTEM_SET_APP_CONFIG',
    systemSetInitDone = 'SYSTEM_SET_INIT_DONE',
};

export type SystemState = {
    themeDark: boolean,
    appConfig: appConfig,
    initDone: boolean,
};
